var map = {
	"./about.md": [
		"./src/assets/markdown/about.md",
		0
	],
	"./application-storage.md": [
		"./src/assets/markdown/application-storage.md",
		1
	],
	"./confirm-schema-migration.md": [
		"./src/assets/markdown/confirm-schema-migration.md",
		2
	],
	"./import-goodfilms.md": [
		"./src/assets/markdown/import-goodfilms.md",
		3
	],
	"./import-jsonld.md": [
		"./src/assets/markdown/import-jsonld.md",
		4
	],
	"./import-netflix.md": [
		"./src/assets/markdown/import-netflix.md",
		5
	],
	"./import-tviso.md": [
		"./src/assets/markdown/import-tviso.md",
		6
	],
	"./viewer.md": [
		"./src/assets/markdown/viewer.md",
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/markdown lazy recursive ^\\.\\/.*\\.md$";
module.exports = webpackAsyncContext;